module.exports = __webpack_public_path__ + "img/sa.8e24fed3.png";